import PhotoDetailModal from '../photo-detail-modal';
import PhotoDetailModalStore from '../photo-detail-modal/store';
import useModal from '@src/utils/hooks/use-modal';

export default class PhotoStore {
  // 图片详情弹窗
  photoDetailModal = new PhotoDetailModalStore();

  viewPhotoDetail = src => {
    this.photoDetailModal.src = src;
    this.imageDetail.open();
  };

  use() {
    this.imageDetail = useModal(PhotoDetailModal, { store: this.photoDetailModal });
  }
}
